import React from "react";
import { motion } from "framer-motion";

const easeOut = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easeOut }}
    >
      {children}
    </MotionTag>
  );
};

// Masked line-by-line reveal for hero
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.14em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: easeOut }}
    >
      {children}
    </motion.span>
  </span>
);

export const Chapter = ({ children }) => (
  <span className="text-xs sm:text-sm tracking-[0.25em] uppercase text-navy/50 font-medium font-sans">
    {children}
  </span>
);
